<h2>
  {{ text1 }} <span class="highlighted">{{ text2 }}</span> {{ text3 }}
</h2>
<div
  class="selected row align-center space-between"
  #selected
  (click)="toggleOptions()"
>
  <div class="row gap-16 align-center">
    <div
      class="icon"
      [style]="
        selectedInterviewPartner?.image || selectedInterviewPartner?.icon
      "
    ></div>
    <rr-icon
      class="icon"
      *ngIf="selectedInterviewPartner?.icon"
      [name]="selectedInterviewPartner.icon"
    ></rr-icon>

    <div class="name">
      {{ selectedInterviewPartner?.name || selectedInterviewPartner?.text }}
    </div>
  </div>
  <rr-icon name="chevron-down" class="pointer icon chevron"></rr-icon>
</div>
<div class="tiny">{{ selectedInterviewPartner.description }}</div>
<div class="row subrow align-center space-between">
  <rr-btn type="Primary" iconEnd="arrow-right" i18n (click)="start.emit()"
    >Start Chat</rr-btn
  >
  <div
    class="selectedpersona row gap-8 align-center"
    (click)="togglePersonas()"
  >
    <div class="row align-center name tiny">
      with&nbsp;<strong>{{
        selectedPersona?.name || selectedPersona?.text
      }}</strong>
    </div>
    <rr-icon name="chevron-down" class="pointer icon chevron"></rr-icon>
    <div class="image" [style]="selectedPersona?.image"></div>
  </div>
</div>
@if(showInterViewPartnerOptions === true){
<div class="backdrop" (click)="toggleOptions()"></div>
<div class="options" [style.width]="optionswidth + 'px'">
  <div
    *ngFor="let option of interviewPartner"
    class="option align-center row gap-16 pointer"
    (click)="selectinterviewPartner(option)"
  >
    <div class="icon" *ngIf="option.image" [style]="option.image"></div>
    <rr-icon *ngIf="option?.icon" [name]="option.icon"></rr-icon>
    <div class="name">{{ option.name || option.text }}</div>
  </div>
</div>
} @if(showPersonaOptions === true){
<div class="backdrop" (click)="togglePersonas()"></div>
<div
  class="options persona"
  #persona
  [style.margin-left]="personamargin + 'px'"
  [style.margin-bottom]="personamarginbottom + 'px'"
>
  <div
    *ngFor="let option of personas"
    class="option align-center row gap-16 pointer"
    (click)="selectPersona(option)"
  >
    <div class="icon" *ngIf="option.image" [style]="option.image"></div>
    <rr-icon *ngIf="option?.icon" [name]="option.icon"></rr-icon>
    <div class="name">{{ option.name || option.text }}</div>
  </div>
</div>
}
